import { render, staticRenderFns } from "./Expertise.vue?vue&type=template&id=53942c41&"
import script from "./Expertise.vue?vue&type=script&lang=ts&"
export * from "./Expertise.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports